import React from "react";

export default function ConfirmModal({ message, onConfirm, onCancel }) {
    return (
        <div className="modal--backdrop modal--confirm">
            <div className="modal d-block" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content rounded-5">
                        <div className="modal-header me-1 ms-1">
                            <h5 className="modal-title">Підтвердження</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onCancel}
                            ></button>
                        </div>
                        <div className="modal-body ms-1 me-1">
                            <p>{message}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-dark rounded-5"
                                onClick={onCancel}
                            >
                                Скасувати
                            </button>
                            <button
                                className="btn main--button ps-4 pe-4"
                                onClick={onConfirm}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
